
export const persistLogin = ({ token, token_type, user, balance }) => {
  localStorage.setItem("authToken", token);
  localStorage.setItem("tokenType", token_type);
  localStorage.setItem("userData", JSON.stringify(user));
  localStorage.setItem("isAuthenticated", "true");

  if (balance) {
    localStorage.setItem("userBalance", JSON.stringify(balance));
  }
};

export const logout = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('tokenType');
  localStorage.removeItem('userData');
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('userBalance');
};
